import _ from 'lodash'
import React from 'react'
import {Provider} from 'react-redux'

import {AppWrapper, Columns, FunnelPage, Grid} from '@influxdata/clockface'

import SplashPageContents from './SplashPageContents'
import FunnelSubHeader from '../shared/FunnelSubheader'
import FunnelHeader from '../shared/FunnelHeader'
import {Marketplace} from '../../types/marketplace'
import {
  Cluster,
  ProviderInfo,
  ProviderRegion,
  Region,
  RegionInfo,
  Regions,
} from '../../types'
// Utils
import {configureStore} from 'js/store'
import LogoWithCubo from 'js/components/LogoWithCubo'
import {setupProviderRegionInitialState} from 'js/components/ProviderRegion/selectors'
import {
  AnalyticsClient,
  GoogleAnalyticsClient,
} from '../../client/GoogleAnalyticsClient'

interface Props {
  clusters: Cluster[]
  marketplace: Marketplace
  analyticsClient?: AnalyticsClient
  identityProvider?: string
  successfulSignup?: boolean
  isSocialSignon?: boolean
}

function clustersToProviderRegion(clusters: Cluster[]) {
  const providerInfo: ProviderInfo[] = _.uniqBy(clusters, 'providerId').map(
    (cluster) => {
      return {
        isAvailable: cluster.isProviderAvailable,
        provider: cluster.providerId,
        title: cluster.providerName,
      }
    }
  )

  const regions: RegionInfo[] = clusters.map((cluster) => ({
    isAvailable: cluster.isRegionAvailable,
    priority: cluster.priority,
    provider: cluster.providerId,
    region: cluster.regionId as Region,
    title: cluster.regionName,
  }))
  const regionInfo: Regions = _.groupBy(regions, 'provider')

  return {
    providerInfo: providerInfo,
    regionInfo: regionInfo,
  } as ProviderRegion
}

const Splash = ({
  clusters,
  marketplace,
  analyticsClient,
  identityProvider,
  successfulSignup,
}: Props): JSX.Element => {
  const providerRegion = clustersToProviderRegion(clusters)
  const store = configureStore({
    providerRegion: setupProviderRegionInitialState(providerRegion),
  })

  const client = analyticsClient || new GoogleAnalyticsClient(window.dataLayer)
  if (successfulSignup) {
    client.send_event('influx_cloud_signup_success', {
      identity_provider: identityProvider,
      marketplace,
    })
  }

  return (
    <Provider store={store}>
      <AppWrapper>
        <FunnelPage logo={<LogoWithCubo />}>
          <Grid.Column
            widthSM={Columns.Ten}
            offsetSM={Columns.One}
            widthMD={Columns.Eight}
            offsetMD={Columns.Two}
          >
            <FunnelHeader text="Welcome to InfluxData" />
            {!marketplace && (
              <FunnelSubHeader text="Just a few things before we get started. No credit card required." />
            )}
          </Grid.Column>
          <SplashPageContents marketplace={marketplace} />
        </FunnelPage>
      </AppWrapper>
    </Provider>
  )
}

export default Splash
